import postal from 'postal';

import { kind as initializeComplete } from '../../actions/completions/InitializeComplete';
import { initializeDB } from '../../initializeDB';
import { State } from '../../State';
import { Task } from '../../Task';
import { idle } from './idle';
import { notIdle } from './notIdle';
import { suspend } from './suspend';

export const kind = 'Initialize';

export function initializeTask(): Task {
  return {
    kind,
    start: async dispatch => {
      const database = await initializeDB();

      dispatch({
        database,
        kind: initializeComplete,
      });

      // This isn't necessary under V2 as we removed the one subscriber to it;
      // `src/rxdb/useRxDB.tsx` used it to `setDbInitialized(true)`
      // TODO: clean this up https://nutrien.atlassian.net/browse/MDP-8188
      postal.publish({
        channel: 'db',
        topic: 'db.initialized',
      });
    },
  };
}

export function initialize(state: State): State {
  if (state.replication) return suspend(state);

  if (state.database) {
    return idle({ ...state, cleaned: false });
  }

  return {
    ...state,
    cleaned: false,
    nextTask: initializeTask(),
    whenIdle: notIdle(state),
  };
}
